import { render, staticRenderFns } from "./defaultTable.vue?vue&type=template&id=4493838a"
import script from "./defaultTable.vue?vue&type=script&lang=js"
export * from "./defaultTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports